import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, ipMatches } from "@/lib/api";

export const ProxyPanel = ({ status, reloadStatus }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [ip, setIp] = useState(null);

  const save = async (value) => {
    setBusy(true);
    try {
      const r = await api.put("/connect/proxy", { proxy_url: value });
      setIp(r.data.ip);
      setUrl("");
      reloadStatus();
      const ok = ipMatches(r.data.ip);
      if (!value) toast("Proxy removed; Dhan traffic goes direct");
      else if (ok) toast.success(`Dhan now sees ${r.data.ip.detectedIP}: IP MATCH, orders allowed`);
      else toast.error(r.data.ip?.error || `Dhan sees ${r.data.ip?.detectedIP}: ${r.data.ip?.ipMatchStatus}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="panel p-4" data-testid="panel-dhan-proxy">
      <div className="eyebrow">Dhan proxy · whitelisted IP</div>
      <p className="mt-2 text-[11px] leading-snug text-slate-400">
        Routes only Dhan API traffic through a proxy on your VPS so Dhan sees your registered static IP. Set it up with <span className="num text-slate-300">deploy/dhan-proxy-setup.sh</span>.
      </p>
      <div className="mt-2 text-xs text-slate-400">In use: <span className="num text-slate-200" data-testid="proxy-current">{status?.proxy || "none (direct)"}</span></div>
      <label className="mt-3 block"><span className="eyebrow !text-[10px]">Proxy URL</span>
        <Input data-testid="input-proxy-url" placeholder="http://orbdesk:PASSWORD@109.121.47.78:3128" className="num mt-1 h-8 bg-slate-900 text-xs" value={url} onChange={(e) => setUrl(e.target.value)} />
      </label>
      <div className="mt-2 flex gap-2">
        <Button data-testid="button-save-proxy" disabled={busy || !url || !status?.client_id} onClick={() => save(url.trim())} className="h-8 flex-1 bg-indigo-500 text-xs text-white hover:bg-indigo-400">{busy ? "Testing via Dhan…" : "Save & test IP"}</Button>
        {status?.proxy && <Button data-testid="button-remove-proxy" disabled={busy} variant="outline" onClick={() => save("")} className="h-8 border-slate-700 text-xs">Remove</Button>}
      </div>
      {ip && (
        <div data-testid="proxy-ip-result" className={`num mt-2 text-[11px] ${ipMatches(ip) ? "up" : "down"}`}>
          {ip.error || `Dhan sees ${ip.detectedIP} · ${ip.ipMatchStatus} · orders ${ip.ordersAllowed ? "allowed" : "blocked"}`}
        </div>
      )}
    </div>
  );
};
